import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#d2e6f1] text-black border-t border-black/10">
      <div className="mx-auto max-w-7xl px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand & Intro */}
          <div className="flex flex-col gap-4">
            <Link to="/" className="flex flex-col">
              <span className="font-serif text-2xl font-semibold tracking-wide text-black">
                Heidi Svelmøe
              </span>
              <span className="text-xs uppercase tracking-[0.2em] text-black/80 font-medium">
                Sang & Mindfulness
              </span>
            </Link>
          </div>

          {/* Hurtige links */}
          <div className="flex flex-col gap-4">
            <h3 className="font-serif text-lg font-semibold text-black tracking-wide">
              Hurtige links
            </h3>
            <div className="flex flex-col gap-2 text-sm text-black/90">
              <Link to="/" className="hover:underline transition-colors">Forside</Link>
              <Link to="/undervisning" className="hover:underline transition-colors">Undervisning</Link>
              <Link to="/om-heidi" className="hover:underline transition-colors">Om Heidi</Link>
              <Link to="/musik" className="hover:underline transition-colors">Musik</Link>
              <Link to="/galleri" className="hover:underline transition-colors">Galleri</Link>
              <Link to="/blog" className="hover:underline transition-colors">Blog</Link>
              <Link to="/kontakt" className="hover:underline transition-colors">Kontakt</Link>
            </div>
          </div>

          {/* Contact Details */}
          <div className="flex flex-col gap-4">
            <h3 className="font-serif text-lg font-semibold text-black tracking-wide">
              Kontakt
            </h3>
            <ul className="flex flex-col gap-3 text-sm text-black/90">
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-black/70 w-4" aria-hidden="true" />
                <a href="tel:27794688" className="hover:underline transition-colors whitespace-nowrap">
                  27794688
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-black/70 w-4" aria-hidden="true" />
                <a href="mailto:heidisvelmoe@gmail.com" className="hover:underline transition-colors whitespace-nowrap">
                  heidisvelmoe@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-black/70 w-4 mt-1" aria-hidden="true" />
                <div className="flex flex-col">
                  <span className="font-medium text-black">Undervisningssted:</span>
                  <span>Kronprinsensgade 7b</span>
                  <span>5000 Odense C</span>
                </div>
              </li>
            </ul>
          </div>

          {/* Følg med */}
          <div className="flex flex-col gap-4">
            <h3 className="font-serif text-lg font-semibold text-black tracking-wide">
              Følg med
            </h3>
            <div className="flex flex-col gap-2 text-sm text-black/90">
              <span className="text-xs uppercase tracking-wider font-semibold text-black/60 pt-0.5">
                Facebook
              </span>
              <a
                href="https://www.facebook.com/profile.php?id=100083316925396"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:underline transition-colors"
              >
                <i className="fa-brands fa-facebook text-black/70 w-4 shrink-0" aria-hidden="true" />
                <span>Sangundervisning & Mindfulness</span>
              </a>
              <a
                href="https://www.facebook.com/heidiherlowdk"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:underline transition-colors"
              >
                <i className="fa-brands fa-facebook text-black/70 w-4 shrink-0" aria-hidden="true" />
                <span>Heidi Svelmøe (Musiker)</span>
              </a>
              <a
                href="https://www.facebook.com/heidisvelmoeherlow"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:underline transition-colors"
              >
                <i className="fa-brands fa-facebook text-black/70 w-4 shrink-0" aria-hidden="true" />
                <span>Heidi Svelmøe (Profil)</span>
              </a>
              <a
                href="https://www.facebook.com/kamillaroyalmusic"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:underline transition-colors"
              >
                <i className="fa-brands fa-facebook text-black/70 w-4 shrink-0" aria-hidden="true" />
                <span>Kamilla Royal</span>
              </a>
              <a
                href="https://www.facebook.com/stellarpirate"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:underline transition-colors"
              >
                <i className="fa-brands fa-facebook text-black/70 w-4 shrink-0" aria-hidden="true" />
                <span>StellarPirate</span>
              </a>

              <span className="text-xs uppercase tracking-wider font-semibold text-black/60 pt-2">
                Instagram
              </span>
              <a
                href="https://www.instagram.com/heidisvelmoe78"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:underline transition-colors"
              >
                <i className="fa-brands fa-instagram text-black/70 w-4 shrink-0" aria-hidden="true" />
                <span>Heidi Svelmøe (@heidisvelmoe78)</span>
              </a>
              <a
                href="https://www.instagram.com/kamillaroyal"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:underline transition-colors"
              >
                <i className="fa-brands fa-instagram text-black/70 w-4 shrink-0" aria-hidden="true" />
                <span>Kamilla Royal (@kamillaroyal)</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-black/10 text-center text-xs text-black/70">
          <p>&copy; {currentYear} Heidi Svelmøe — Sang & Mindfulness. Alle rettigheder forbeholdes.</p>
        </div>
      </div>
    </footer>
  );
}
